export default "__VITE_ASSET__V2Washr6__"